import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { cn } from 'lib/utils';
import EmptyState from 'components/EmptyState';
import type { JiraFix } from 'api/sectorAlignmentApi';
import { JIRA_GRID, type Tagged } from './rows';
import JiraRow from './JiraRow';

/** Board 6/B7: information only, these are fixed in their referential, never from GPS. */
const JiraTab = ({ fixes, filtered }: { fixes: Tagged<JiraFix>[]; filtered: boolean }) => {
  const { t } = useTranslation();
  if (fixes.length === 0 && filtered) return <EmptyState title={t('No result for this filter')} />;
  if (fixes.length === 0) return <EmptyState icon={Check} tone="success" title={t('Nothing to correct')} />;

  return (
    <>
      <div role="table" aria-label={t('To correct')}>
        <div role="row" className={cn(JIRA_GRID, 'h-[42px] border-b text-xs font-semibold text-muted-foreground')}>
          <span role="columnheader">{t('Ticket or store')}</span>
          <span role="columnheader">{t('Desk')}</span>
          <span role="columnheader">{t('Referential')}</span>
          <span role="columnheader">{t('Problem')}</span>
        </div>
        {fixes.map((fix, i) => <JiraRow key={`${fix.sd}-${fix.reason}-${fix.store ?? fix.tickets?.[0]?.key}-${i}`} fix={fix} />)}
      </div>
      <p className="border-t px-5 py-[11px] text-[12.5px] text-muted-foreground">{t('To correct in the indicated referential. No action possible from GPS.')}</p>
    </>
  );
};

export default JiraTab;
